import {
  ChartNoAxesColumnIncreasing,
  GraduationCap,
  LayoutDashboard,
  Library,
  SquareStack,
} from 'lucide-vue-next'

export const mainNavigation = [
  {
    label: 'Dashboard',
    name: 'dashboard',
    icon: LayoutDashboard,
  },
  {
    label: 'Learn',
    name: 'learn',
    icon: GraduationCap,
  },
  {
    label: 'Review',
    name: 'review',
    icon: SquareStack,
  },
  {
    label: 'Library',
    name: 'library',
    icon: Library,
  },
  {
    label: 'Progress',
    name: 'progress',
    icon: ChartNoAxesColumnIncreasing,
  },
]
